var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatCloseEmojiIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160969",
    "data-name": "Group 160969",
    transform: "translate(-1289.142 -528.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smiley_18px",
    transform: "translate(1289 528)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 17,
    height: 17,
    transform: "translate(0.142 0.142)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smile_1_",
    "data-name": "smile (1)",
    transform: "translate(0.521 0.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83106",
    "data-name": "Path 83106",
    d: "M7.521,0A7.521,7.521,0,1,1,0,7.521,7.521,7.521,0,0,1,7.521,0Z",
    transform: "translate(0.419 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#555",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M8,14a5.076,5.076,0,0,0,3.76,1.88A5.076,5.076,0,0,0,15.521,14",
    transform: "translate(-3.625 -5.406)",
    fill: "rgba(0,0,0,0)",
    stroke: "#555",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x2: 0.009,
    transform: "translate(5.878 5.084)",
    fill: "none",
    stroke: "#555",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    x2: 0.009,
    transform: "translate(10.39 5.084)",
    fill: "none",
    stroke: "#555",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140097",
    "data-name": "Rectangle 140097",
    width: 17.861,
    height: 3.76,
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 2.612, 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_83107",
    "data-name": "Path 83107",
    d: "M77.3,93.3,64,80",
    transform: "translate(1226.813 449.916)",
    fill: "none",
    stroke: "#555",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatCloseEmojiIcon);
export default __webpack_public_path__ + "static/media/live-chat-close-emoji-icon.5f591c0ed8a89f151ac7729b994eb176.svg";
export { ForwardRef as ReactComponent };